import React from 'react';
import QuickUploader from '../components/debug/QuickUploader';

export default function QuickUploaderPage() {
  return <QuickUploader />;
}